'use strict';

import React, { Component } from 'react'

import { mergeDeep } from '@root/utility'

export default class AutoCompletedField extends Component
{
	state =
	{
		autocomplete: false,
		current_autocomplete: 0,
		id: ++app.form_index
	};

	used_id = '';

	propositions = [];

	componentWillMount ()
	{
		const component = this, props = this.props;

		if (props.referenced_value === true && !props.value)
		{
			var data =
			{
				value: '',
				name: props.name,
				display_name: '__display__' + props.name,
				default: true
			};

			props.onChange(null, data);
		}

		component.setState(
		{
			autocomplete: false,
			current_autocomplete: 0
		});

		app.push(
		{
			type: 'listener',
			event: 'documentClick',
			cb: component.handleDocumentClick
		});

		app.push(
		{
			event: 'autoCompleteChange',
			cb: component.render.bind(component)
		});
	}

	componentWillUnmount ()
	{
		var component = this;

		app.delete(
		{
			type: 'listener',
			event: 'documentClick',
			cb: component.handleDocumentClick
		});

		app.delete(
		{
			event: 'autoCompleteChange',
			cb: component.render.bind(component)
		});
	}

	handleDocumentClick = (source) =>
	{
		var component = this, props = this.props;

		if (source === component) return;

		component.setState(
		{
			autocomplete: false,
			current_autocomplete: 0
		});
	}

	handleFocus = (e) =>
	{
		var component = this, props = this.props;

		if (props.onFocus) props.onFocus(e);

		component.setState(
		{
			autocomplete: true,
			current_autocomplete: 0
		});
	}

	handleChange = (e) =>
	{
		var component = this, props = this.props;

		e.stopPropagation();

		var data =
		{
			value: e.target.value,
			name: props.name
		};

		if (props.referenced_value === true)
		{
			data.display_name = '__display__' + props.name;
		}

		component.used_id = '';

		component.setState(
		{
			autocomplete: true,
			current_autocomplete: 0
		});

		props.onChange(e, data);
	}

	handleAutoComplete = (proposition) =>
	{
		const component = this, props = this.props;

		let value, proposition_data = mergeDeep({ }, proposition);

		if (!proposition) return;

		if (proposition.value instanceof Array)
		{
			value = proposition.value.join(' ');
		}
		else if (proposition.value instanceof Object)
		{
			value = Object.keys(proposition.value).reduce(function (value, prop)
			{
				if (props.display_fields instanceof Array === false)
				{
					if (value) value += ' ';

					value += proposition.value[prop];
				}
				else if (props.display_fields.indexOf(prop) !== -1)
				{
					if (value) value += ' ';

					value += proposition.value[prop];
				}

				return value;
			}, '');
		}

		proposition_data.value = value;

		var data =
		{
			value: value,
			name: props.name,
			data: proposition_data
		};

		if (props.referenced_value === true)
		{
			data.display_name = '__display__' + props.name;
		}

		component.used_id = proposition.id;

		component.setState(
		{
			autocomplete: false,
			current_autocomplete: 0
		});

		props.onChange(null, data);
	}

	preventClickBubbling = (e) =>
	{
		e.stopPropagation();

		app.emit('documentClick', this);
	}

	handleKeyDown = (e) =>
	{
		var component = this, props = this.props;

		if (e.keyCode === 13)
		{
			e.preventDefault(); // Prevent enter to submit form

			component.handleAutoComplete(
				component.propositions[component.state.current_autocomplete-1]
			);
		}

		if (e.keyCode === 40) // arrow down
		{
			if (component.state.current_autocomplete <= component.propositions.length-1)
			{
				component.setState(
				{
					current_autocomplete: component.state.current_autocomplete + 1
				});
			}
		}
		else if (e.keyCode === 38) // arrow up
		{
			if (component.state.current_autocomplete > 1)
			{
				component.setState(
				{
					current_autocomplete: component.state.current_autocomplete - 1
				});
			}
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		var label, info, warning, error, iterator = 0, propositions;

		var class_name = props.className || 'c-form-element';
			class_name += ' c-form-element--autocompleted';

		var autocomplete_class = 'c-autocomplete';

		var status = (props.status || { })[props.name] || { };

		let front_indicator =
		(
			<svg className="o-svg-icon o-svg-icon--eye c-form-label__icon">
				<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
			</svg>
		);

		if (props.front_indicator !== true)
		{
			front_indicator = undefined;
		}

		if (props.label)
		{
			label =
			(
				<label className="c-form-label"
					htmlFor={ (props.id_prefix || '') + component.state.id }>
					{ front_indicator }
					{ props.label }
				</label>
			);
		}

		if (status.info)
		{
			info =
			(
				<div className="c-form-label c-form-label--info">
					{ status.info }
				</div>
			);

			class_name += ' c-form-element--info';
		}

		if (status.warning)
		{
			warning =
			(
				<div className="c-form-label c-form-label--warning">
					{ status.warning }
				</div>
			);

			class_name += ' c-form-element--warning';
		}

		if (status.error)
		{
			error =
			(
				<div className="c-form-label c-form-label--error">
					{ status.error }
				</div>
			);

			class_name += ' c-form-element--error';
		}

		component.propositions = (props.data || []).slice()
		.filter(function (data, index)
		{
			var searched = props.value || '';
			searched = searched.toLowerCase();

			if (data.id === component.used_id) return false;

		/**
		 * Search every word in every word from the field value.
		 *
		 * @type    { Boolean } true if a match is found.
		 */
			if (typeof data.value === 'string')
			{
				return Boolean(data.value.split(' ').find(function (word)
				{
					return Boolean(searched.split(' ').find(function (searched_word)
					{
						return word.toLowerCase().indexOf(searched_word.toLowerCase()) !== -1;
					}));
				}));
			}
		/**
		 * Search every word in every word from every field value.
		 *
		 * @type    { Boolean } true if a match is found.
		 */
			else if (data.value instanceof Object)
			{
				return Boolean(Object.keys(data.value).find(function (prop)
				{
					let value = String(data.value[prop]) || '';

					return Boolean(searched.split(' ').find(function (searched_word)
					{
						return Boolean(value.split(' ').find(function (word)
						{
							return word.toLowerCase().indexOf(searched_word.toLowerCase()) !== -1;
						}));
					}));
				}));
			}
			else
			{
				return false;
			}
		});

	/**
	 * IMMUTABLE copy. Because it's linked to props and app.state otherwise...
	 **/
		component.propositions = component.propositions.map(function (element)
		{
			let copy;

			if (element instanceof Array)
			{
				copy = element.slice();
			}
			else if (element instanceof Object)
			{
				copy = mergeDeep({ }, element);
			}
			else
			{
				return element;
			}

			return copy;
		});

		propositions = component.propositions.slice(0, 20)
		.map(function (data, index)
		{
			let class_name = 'c-autocomplete__item', value = data.value;

			if (index + 1 === component.state.current_autocomplete)
			{
				class_name += ' js-hover';
			}

			if (data.value instanceof Array)
			{
				value = data.value.reduce((value, str) => value + ' ' + str, '');
			}
			else if (data.value instanceof Object)
			{
				value = Object.keys(data.value).reduce(function (final_value, prop)
				{
					if (props.display_fields instanceof Array === false)
					{
						if (final_value) final_value += ' ';

						final_value += data.value[prop];
					}
					else if (props.display_fields.indexOf(prop) !== -1)
					{
						if (final_value) final_value += ' ';

						final_value += data.value[prop];
					}

					return final_value;
				}, '');
			}

			var output =
			(
				<li onClick={ function () { component.handleAutoComplete(data); } }
					className={ class_name } key={ ++iterator }>
					{ value }
				</li>
			);

			return output;
		});

		if (propositions.length > 0)
		{
			if (props.title)
			{
				propositions.unshift
				(
					<li className="c-autocomplete__label" key={ 0 }>
						{ props.title }
					</li>
				);
			}

			if (component.state.autocomplete === true)
			{
				autocomplete_class += ' ' + autocomplete_class + '--visible';
			}

			if (props.alt_class)
			{
				autocomplete_class += ' ' + props.alt_class;
			}
		}

		var output =
		(
			<div className={ class_name } onClick={ component.preventClickBubbling }>

				{ label }

				{ info }

				{ warning }

				{ error }

				<input className="c-form__input" type={ props.type || 'test' }
					value={ props.value || '' }
					id={ props.id || (props.id_prefix || '') + state.id }
					spellCheck="false" autoComplete="off"
					autoFocus={ props.autoFocus }
					name={ props.referenced_value === true ?
						('__display__' + props.name) : props.name }
					onChange={ component.handleChange }
					onFocus={ component.handleFocus }
					onKeyDown={ component.handleKeyDown }
					placeholder= { props.placeholder }
					ref={ props['input-ref'] }
				/>

				<ul className={ autocomplete_class }>
					{ propositions }
				</ul>

			</div>
		);

		return output;
	}
}